import { app } from "js/namespaces";
import React, { Component } from "reactn";
import { Dialog, IconButton, Icon } from "@material-ui/core";

export default class BeautifulDialog extends Component {
    handleClose = () => {
        let {
            preventClose,
            onClose,
            closeDialog,
        } = this.props;

        if (preventClose) {
            return;
        }

        if (onClose) {
            onClose();
            return;
        }

        closeDialog && closeDialog();
    }

    render() {
        const {
            closeButton,
            closeDialog, // react throws a warning if we pass the closeDialog prop through <Dialog>
            preventClose,
            maxWidth = "sm",
            fullWidth = true,
            ...dialogProps
        } = this.props;

        let style = this.props.style || {};
        if (this.props.zIndex) {
            style = {
                ...style,
                zIndex: this.props.zIndex
            };
        }

        // check for text alignment
        if (this.props.align) {
            style = {
                ...style,
                textAlign: this.props.align
            };
        }

        return (
            <Dialog
                PaperProps={this.props.PaperProps}
                classes={{ paperScrollPaper: "dialog-paper" }}
                className="beautiful-dialog"
                style={style}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                disableEnforceFocus={true}
                onEscapeKeyDown={event => {
                    event.stopPropagation();
                    this.handleClose();
                }}
                {...dialogProps}
                onClose={this.handleClose}
                open
                hideBackdrop={this.props.hideBackdrop}
                disableBackdropClick={this.props.hideBackdrop}
                disableEscapeKeyDown={this.props.hideBackdrop}
            >
                {
                    // !this.props.preventClose &&
                    (closeButton || app.isConstrained) &&
                    <IconButton
                        className="exit-button"
                        onClick={this.props.closeDialog}
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 1000
                        }}
                    >
                        <Icon>close</Icon>
                    </IconButton>
                }
                {this.props.children}
            </Dialog>
        );
    }
}
